import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { DataBuild } from 'src/app/models/data-build';
import { WidgetService } from 'src/app/services/widget.service';
import { DataBuildsService } from 'src/app/services/data-builds.service';
import { TeamsService } from 'src/app/services/teams.service';

@Component({
    selector: 'app-builds-widget',
    templateUrl: './builds-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './builds-widget.component.scss'],
    standalone: false
})
export class BuildsWidgetComponent extends BaseWidgetComponent implements OnInit {
  @Output() onDiff = new EventEmitter<{ parentId: string; left: string; right: string }>();
  @Output() onBuildSelect = new EventEmitter<{ parentId: string; rdsName: string; runId: number; username: string; isArchived: boolean }>();
  @Output() onNewBuild = new EventEmitter<{ parentId: string; cloneSchema?: any }>();

  constructor(
    private _widgetService: WidgetService,
    private _dataBuildsService: DataBuildsService,
    private _teamsService: TeamsService
  ) {
    super();
    (<any>window).buildsWidget = this;
  }

  ngOnInit(): void {
    this._subs.add = this._widgetService.resize$.subscribe(() => {
      if ((<any>window).builds) (<any>window).builds.onResize();
    });
  }

  onBuildClick($event: { rdsName: string; runid: number; user: string; isArchived: boolean }) {
    this.onBuildSelect.emit({
      parentId: this.id,
      rdsName: $event.rdsName,
      runId: $event.runid,
      username: $event.user,
      isArchived: $event.isArchived
    });
  }

  async onCloneClick($event: { runid: number }) {
    const build: any = await this._dataBuildsService.loadOneAsync(this.teamName, $event.runid);
    if (!build) return;

    const cloneSchema = { ...build.schema, name: `build_${Date.now().toString()}` };
    this.onNewBuild.emit({ parentId: this.id, cloneSchema });
  }

  async onDiffClick($event: { left: DataBuild; right: DataBuild }) {
    const config = await this._teamsService.getConfigAsync(this.teamName);
    const encode = (x: DataBuild) => encodeURI(`${config.path.logs}/${x.runid}/${x.rdsName}.json`);
    const left = encode($event.left);
    const right = encode($event.right);
    this.onDiff.emit({ parentId: this.id, left, right });
  }

  onAddClick() {
    console.log('onAddClick called, emitting onNewBuild');
    this.onNewBuild.emit({ parentId: this.id });
  }
}
